import React from "react"
import {
  OverviewDataFragment,
  wpErvaringFragment,
  wpVacatureFragment,
} from "../../__generated__/graphql-gatsby"
import PageBuilder from "../pageBuilder"
import SEO from "../SEO"

interface IProps {
  data: Maybe<wpErvaringFragment | wpVacatureFragment>
  overviewData?: Maybe<Array<Maybe<OverviewDataFragment>>>
  sessionKey: string
}

const BaseComponent: React.FC<IProps> = ({
  data,
  overviewData,
  sessionKey,
}) => {
  const seo = data?.seo
  const page_builder = data?.page_builder
  const uri = data?.uri

  return (
    <>
      <SEO
        title={seo?.title}
        description={seo?.metaDesc}
        ogTitle={seo?.opengraphTitle}
        ogDescription={seo?.opengraphDescription}
        img={{
          url: seo?.opengraphImage?.sourceUrl,
          alt: seo?.opengraphImage?.altText,
          width: seo?.opengraphImage?.mediaDetails?.width,
          height: seo?.opengraphImage?.mediaDetails?.height,
        }}
        siteName={seo?.opengraphSiteName}
        canonical={uri}
      />
      <PageBuilder
        blocks={page_builder?.pageBuilder}
        overviewData={overviewData}
        sessionKey={sessionKey}
      />
    </>
  )
}

export default BaseComponent
